<template>
  <div class="fillcontain">
    <head-top></head-top>
    <!-- <div style="font-size:14pt;font-weight: 400;margin-top:10px;margin-left:10px">欢迎使用网媒资源发布管理平台</div>
    <div style="height:100px;position: relative;">
      <div class="photo"></div>
      <div class="welcome">欢迎您，xxx</div>
      <div class="time">本次登陆日期：</div>
    </div>-->

    <div class="right_box">
      <div class="money_box" style="height: 280px">
        <div class="notice_title">
          <p style="margin: 0">账户余额</p>
        </div>
        <div style="width: 50%; float: left">
          <p style="margin-top: 20px">姓名：{{ username }}</p>
          <p>手机号：{{ phone }}</p>
          <p>微信：{{ weixin }}</p>
          <p>QQ：{{ QQ }}</p>
          <el-button style="margin-left: 10px" size="mini" @click="toChange"
            >修改资料</el-button
          >
          <el-button style="margin-left: 10px" size="mini" @click="toBangding"
            >修改手机号</el-button
          >
          <p v-if="kefu" style="margin-top: 20px">专属客服：{{ kefu }}</p>
        </div>
        <div style="width: 50%; float: left">
          <div style="margin-top: 20px">
            <a style="font-weight: bold">账户余额：</a>
            <a style="color: #e0891b">￥{{ balance }}</a>
            <el-button
              type="warning"
              size="mini"
              style="margin-left: 10px"
              @click="pay"
              >充值</el-button
            >
          </div>
          <div style="margin-top: 10px">
            <el-button @click="rechargeList" size="mini">充值记录</el-button>
            <el-button @click="detailedList" size="mini">账单明细</el-button>
          </div>
          <div style="margin-top: 10px">
            <a style="font-weight: bold">我的收益：</a>
            <a style="color: #e0891b">￥{{ income }}</a>
            <el-button
              type="warning"
              size="mini"
              style="margin-left: 10px"
              @click="zhuanisible = true"
              >转化</el-button
            >
            <el-button
              type="warning"
              size="mini"
              style="margin-left: 10px"
              @click="moneyDialog = true"
              >提现</el-button
            >
          </div>
          <div style="margin-top: 10px">
            <el-button @click="toWithdrawal" size="mini">收益明细</el-button>
            <el-button @click="toTransferList" size="mini">提现记录</el-button>
          </div>
          <div style="margin-top: 10px">
            <a style="font-weight: bold">分销收益：</a>
            <a style="color: #e0891b">￥{{ fxIncome + waitDistribution }}</a>
            <el-button
              type="warning"
              size="mini"
              style="margin-left: 10px"
              @click="fxisible = true"
              >转为收益</el-button
            >
          </div>
          <div style="margin-top: 10px">
            <el-button @click="toWithdrawalfx" size="mini">收益明细</el-button>
            <el-button @click="toTransferListfx" size="mini"
              >我的分销用户</el-button
            >
          </div>
        </div>
        <!-- <el-button type="primary" style="margin-left:10px" @click="pay">充值</el-button>
        <el-button @click="rechargeList">充值记录</el-button>
        <el-button @click="detailedList">账单明细</el-button>-->
      </div>
      <div class="money_box" style="min-height: 368px">
        <div class="notice_title">
          <p>用户须知</p>
          <a
            style="top: 10px; right: 90px; cursor: pointer; color: #00479b"
            @click="nextXuzhi"
            >上一页</a
          >
          <a style="top: 10px; right: 70px; cursor: pointer; color: #00479b">{{
            xuzhiNum
          }}</a>
          <a
            style="top: 10px; right: 20px; cursor: pointer; color: #00479b"
            @click="lastXuzhi"
            >下一页</a
          >
        </div>
        <div v-for="item in xuzhi" :key="item.id" class="notice_content">
          <div
            v-if="item.strong"
            @click="goMustKnow(item.id)"
            style="
              margin: 10px;
              padding: 10px;
              font-size: 11pt;
              font-weight: bold;
              overflow: hidden;
              width: 80%;
              white-space: nowrap;
              text-overflow: ellipsis;
              cursor: pointer;
            "
          >
            {{ item.title == "" ? item.content : item.title }}
          </div>
          <p
            v-else
            @click="goMustKnow(item.id)"
            style="
              padding: 10px;
              font-size: 11pt;
              overflow: hidden;
              width: 80%;
              white-space: nowrap;
              text-overflow: ellipsis;
              cursor: pointer;
            "
          >
            {{ item.title == "" ? item.content : item.title }}
          </p>
          <p
            style="
              padding: 10px;
              color: #9b9b9b;
              font-size: 9pt;
              padding-top: 0;
            "
          >
            {{ item.time }}
          </p>
        </div>
      </div>
    </div>
    <div class="notice_box">
      <div class="enter_box">
        <div
          class="enter_btn"
          style="margin-left: 40px; cursor: pointer"
          @click="toMedia"
        >
          <img src="../assets/icon/1.png" />
          <p>媒体资源</p>
        </div>
        <div class="enter_btn" style="cursor: pointer" @click="toPublish">
          <img src="../assets/icon/2.png" />
          <p>文章发布</p>
        </div>
        <div class="enter_btn" style="cursor: pointer" @click="toText">
          <img src="../assets/icon/3.png" />
          <p>稿件管理</p>
        </div>
        <div class="enter_btn" style="cursor: pointer" @click="toOrder">
          <img src="../assets/icon/4.png" />
          <p>我的订单</p>
        </div>
      </div>
      <div class="notice_title">
        <p>通知公告</p>
        <a
          style="top: 10px; right: 90px; cursor: pointer; color: #00479b"
          @click="nextPage"
          >上一页</a
        >
        <a style="top: 10px; right: 70px; cursor: pointer; color: #00479b">{{
          pageNum
        }}</a>
        <a
          style="top: 10px; right: 20px; cursor: pointer; color: #00479b"
          @click="lastPage()"
          >下一页</a
        >
      </div>
      <div v-for="item in notice" :key="item.id" class="notice_content">
        <div
          v-if="item.strong"
          @click="
            dialogVisible = true;
            detail = item.content;
          "
          style="
            padding: 10px;
            font-size: 11pt;
            font-weight: bold;
            overflow: hidden;
            width: 80%;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
          "
        >
          {{ item.content }}
        </div>
        <p
          v-else
          @click="
            dialogVisible = true;
            detail = item.content;
          "
          style="
            padding: 10px;
            font-size: 11pt;
            overflow: hidden;
            width: 80%;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
          "
        >
          {{ item.content }}
        </p>
        <p
          style="padding: 10px; color: #9b9b9b; font-size: 9pt; padding-top: 0"
        >
          {{ item.time }}
        </p>
      </div>
    </div>
    <el-dialog title="公告详情" :visible.sync="dialogVisible" width="60%">
      <p style="white-space: pre-line">{{ detail }}</p>
      <!-- {{}} -->
    </el-dialog>
    <el-dialog title="转化为余额" :visible.sync="zhuanisible" width="40%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="转化金额" style="clear: both">
          <el-input
            size="small"
            style="width: 50%"
            v-model="zhuanPrice"
            :placeholder="'最大:' + income"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button @click="zhuanHua">确定</el-button>
      <!-- {{}} -->
    </el-dialog>
    <el-dialog title="转化为收益" :visible.sync="fxisible" width="40%">
      <el-form ref="form" label-width="100px">
        <div style="margin-bottom: 10px">可转化余额为：{{ fxIncome }}元</div>
        <div style="margin-bottom: 10px">
          (订单完成时间满足30天以上,才能生效提现)
        </div>
      </el-form>
      <el-button @click="sureFx">确定转化</el-button>
      <!-- {{}} -->
    </el-dialog>
    <el-dialog title="余额提现" :visible.sync="moneyDialog" width="40%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="手机号：" style="clear: both">
          <el-input style="width: 80%" v-model="phone" disabled>
            <template slot="append">
              <el-button v-show="codeshow" @click="getCode"
                >获取验证码</el-button
              >
              <el-button v-show="!codeshow">{{ count }} s</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码：" style="clear: both">
          <el-input
            size="small"
            style="width: 80%"
            v-model="code"
            placeholder="请输入验证码"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付宝账号：" style="clear: both">
          <el-input style="width: 80%" size="small" v-model="huming"></el-input>
        </el-form-item>
        <el-form-item label="收款方姓名：" style="clear: both">
          <el-input
            style="width: 80%"
            size="small"
            v-model="zhanghu"
          ></el-input>
        </el-form-item>
        <el-form-item label="提现金额：" style="clear: both">
          <el-input
            style="width: 80%"
            size="small"
            :placeholder="'可提现：' + income + '元'"
            v-model="price"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="moneyDialog = false">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="余额提现" :visible.sync="fxTvisible" width="40%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="手机号：" style="clear: both">
          <el-input style="width: 80%" v-model="phone" disabled>
            <template slot="append">
              <el-button v-show="codeshow" @click="getCode"
                >获取验证码</el-button
              >
              <el-button v-show="!codeshow">{{ count }} s</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码：" style="clear: both">
          <el-input
            size="small"
            style="width: 80%"
            v-model="code"
            placeholder="请输入验证码"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付宝账号：" style="clear: both">
          <el-input style="width: 80%" size="small" v-model="huming"></el-input>
        </el-form-item>
        <el-form-item label="收款方姓名：" style="clear: both">
          <el-input
            style="width: 80%"
            size="small"
            v-model="zhanghu"
          ></el-input>
        </el-form-item>
        <el-form-item label="提现金额：" style="clear: both">
          <el-input
            style="width: 80%"
            size="small"
            :placeholder="'可提现：' + income + '元'"
            v-model="price"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="moneyDialog = false">取 消</el-button>
        <el-button type="primary" @click="surefx">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import { mapState } from "vuex";
import myAxios from "../myAxios";
export default {
  data() {
    return {
      fxIncome: 0,
      fxisible: false,
      fxTvisible: false,
      fxZvisible: false,
      dialogVisible: false,
      zhuanisible: false,
      zhuanPrice: "",
      detail: "",
      notice: [],
      xuzhi: [],
      pageNum: 1,
      xuzhiNum: 1,
      // 我的资料
      username: localStorage.getItem("username"),
      balance: 0,
      phone: "",
      QQ: "",
      weixin: "",
      // 提现相关
      waitDistribution: 0,
      moneyDialog: false,
      huming: "",
      zhanghu: "",
      price: "",
      income: "",
      code: "",
      codeshow: true,
      count: "",
      kefu: "",
      timer: null,
    };
  },
  created() {
    console.log("store", this.$store.state);
    this.getNotices(1);
    this.getXuzhi(1);
    this.getMydata();
  },
  components: {
    HeadTop,
  },
  computed: {},
  methods: {
    fxToIncome() {},
    sureFx() {
      myAxios
        .get(`client_user/Distribution2Income/v1?username=${this.username}`)
        .then((res) => {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
          });
          this.getMydata();
        });
    },
    goMustKnow(id) {
      let newpage = this.$router.resolve({
        name: "mustknow",
        query: {
          id: id,
          index: this.xuzhiNum,
        },
      });
      window.open(newpage.href, "_blank");
      // this.$router.push({ path: "mustknow", query: { id: id } });
    },
    toMedia() {
      this.$router.push("/chooersmedia?i=1");
    },
    toPublish() {
      this.$router.push("/addArticle");
    },
    toOrder() {
      this.$router.push("/orderList");
    },
    toText() {
      this.$router.push("/manuscriptList");
    },
    pay() {
      let text = this.$router.resolve({
        path: "/balanceRecharge",
      });
      window.open(text.href, "_blank");
    },
    rechargeList() {
      this.$router.push("/rechargeList");
    },
    detailedList() {
      this.$router.push("/detailedList");
    },
    toChange() {
      this.$router.push("/mydata");
    },
    toBangding() {
      this.$router.push("/changePhone");
    },
    toWithdrawal() {
      this.$router.push("/withdrawal");
    },
    toTransferList() {
      this.$router.push("/transferList");
    },
    toWithdrawalfx() {
      this.$router.push("/withdrawalfx");
    },
    toTransferListfx() {
      this.$router.push("/myfxusers");
    },
    getNotices(i) {
      myAxios
        .get(`client_user/Notices/v1?index=${i}&size=7&type=1`)
        .then((res) => {
          this.notice = res.data;
        });
    },
    getXuzhi(i) {
      myAxios
        .get(`client_user/Notices/v1?index=${i}&size=3&type=2`)
        .then((res) => {
          this.xuzhi = res.data;
        });
    },
    getMydata() {
      myAxios
        .get(`client_user/Personal/v1?username=${this.username}`)
        .then((res) => {
          this.balance = res.data.balance;
          this.phone = res.data.phone;
          localStorage.setItem("phone", this.phone);
          this.QQ = res.data.QQ;
          this.income = res.data.income;
          this.kefu = res.data.kefu;
          this.weixin = res.data.weixin;
          this.fxIncome = res.data.distribution;
          this.waitDistribution = res.data.waitDistribution;
          localStorage.setItem("wxCode", res.data.QRCode);
        });
    },
    lastPage() {
      var num = this.pageNum + 1;
      myAxios
        .get(`client_user/Notices/v1?index=${num}&size=7&type=1`)
        .then((res) => {
          if (res.total > 0) {
            this.pageNum = this.pageNum + 1;
            this.notice = res.data;
          } else {
            this.$notify({
              title: "提示",
              message: "当前为最后一页",
              type: "success",
            });
          }
        });
    },
    lastXuzhi() {
      var num = this.xuzhiNum + 1;
      myAxios
        .get(`client_user/Notices/v1?index=${num}&size=3&type=2`)
        .then((res) => {
          if (res.total > 0) {
            this.xuzhiNum = this.xuzhiNum + 1;
            this.xuzhi = res.data;
          } else {
            this.$notify({
              title: "提示",
              message: "当前为最后一页",
              type: "success",
            });
          }
        });
    },
    nextPage() {
      if (this.pageNum == 1) {
        this.$notify({
          title: "提示",
          message: "当前为第一页",
          type: "success",
        });
      } else {
        this.pageNum = this.pageNum - 1;
        this.getNotices(this.pageNum);
      }
    },
    nextXuzhi() {
      if (this.xuzhiNum == 1) {
        this.$notify({
          title: "提示",
          message: "当前为第一页",
          type: "success",
        });
      } else {
        this.xuzhiNum = this.xuzhiNum - 1;
        this.getXuzhi(this.xuzhiNum);
      }
    },
    getCode() {
      var that = this;
      myAxios
        .get(`/client_login/GetSmsCode/v1?phone=${this.phone}`)
        .then((res) => {
          if (res.code == 0) {
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeshow = false;
              // this.phone = "";
              this.code = "";
              this.password = "";
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeshow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: res.message,
              offset: 100,
            });
          }
        })
        .catch(function (error) {});
      const TIME_COUNT = 59;
    },
    zhuanHuafx() {
      // zhuanPrice
    },
    surefx() {},
    // 确定提现
    sure() {
      if (Number(this.price) > this.income) {
        this.$message({
          title: "提示",
          message: "提现金额请不要大于余额",
        });
        return;
      }
      if (
        this.price == "" ||
        this.huming == "" ||
        this.zhanghu == "" ||
        this.code == ""
      ) {
        this.$message({
          title: "提示",
          message: "请填写完整",
        });
        return;
      }
      myAxios
        .post(
          `/client_media/Encash/v1?username=${this.username}&price=${this.price}&payeeAccount=${this.huming}&payeeRealName=${this.zhanghu}&code=${this.code}`
        )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: res.data,
            });
            this.moneyDialog = false;
          } else {
            this.$message({
              message: res.message,
            });
          }
        });
    },
    zhuanHua() {
      if (Number(this.zhuanPrice) > this.income) {
        this.$message({
          title: "提示",
          message: "请不要超过收益额",
        });
        return;
      }
      myAxios
        .post(
          `/client_user/ExchangeBalance/v1?username=${this.username}&price=${this.zhuanPrice}`
        )
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: res.data,
            });
            this.zhuanisible = false;
            this.getMydata();
          } else {
            this.$message({
              type: "success",
              message: res.message,
            });
          }
        });
    },
  },
};
</script>

<style lang="less">
@import "../style/mixin";
.notice_content {
  border-bottom: 1px solid #eeeeee;
  p {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 10pt;
  }
}
.enter_box {
  border-bottom: 1px solid #cecece;
  overflow: hidden;
  height: 128px;
  position: relative;
  // a {
  //   position: absolute;
  //   top: 52px;
  //   font-size: 10pt;
  //   width: 60px;
  //   text-align: center;
  //   line-height: 60px;
  //   height: 60px;
  //   border: 1px solid rgb(146, 146, 146);
  //   border-radius: 60px;
  //   cursor: pointer;
  // }
}
.notice_title {
  width: 100%;
  border-bottom: 1px solid #cecece;
  // font-weight: bold;
  position: relative;
  p {
    padding: 8px;
  }
  a {
    font-weight: normal;
    font-size: 9pt;
    position: absolute;
  }
}
.money_box {
  border: 1px solid #cecece;
  p {
    margin: 10px;
  } // height: 500px;
  // margin-top: 20px;
}
.right_box {
  float: left;
  width: 47%;
  margin-left: 2%;
  margin-top: 2%;
  height: 650px;
}
.notice_box {
  border: 1px solid #cecece;
  width: 47%;
  margin-left: 2%;
  margin-top: 2%;
  height: 650px;
  float: left;
  overflow: scroll;
}
.photo {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background-color: aliceblue;
  left: 10px;
  top: 20px;
  position: absolute;
}
.welcome {
  position: absolute;
  top: 20px;
  left: 80px;
}
.time {
  position: absolute;
  top: 45px;
  left: 80px;
  font-size: 10pt;
}
.explain_text {
  margin-top: 20px;
  text-align: center;
  font-size: 20px;
  color: #333;
}
.admin_set {
  width: 60%;
  background-color: #f9fafc;
  min-height: 400px;
  margin: 20px auto 0;
  border-radius: 10px;
  ul > li {
    padding: 20px;
    span {
      color: #666;
    }
  }
}
.admin_title {
  margin-top: 20px;
  .sc(24px, #666);
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  margin-top: 10px;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.enter_btn {
  text-align: center;
  margin-right: 2%;
  margin-top: 1.5%;
  height: 110px;
  float: left;
  width: 110px;
  border: 1px solid rgb(219, 219, 219);
  img {
    width: 60px;
    height: 60px;
    margin-top: 10px;
    border-radius: 40px;
  }
  p {
    font-size: 8px;
  }
}
</style>
